import React from 'react';
import { wagwebTheme } from '@/theme/wagwebTheme';
import background from '@/assets/illustrations/petted.png';
import logoIcon from '@/assets/icons/pettedlogo.svg';
import { GenericHealthArticleAdvertCard } from '../Generic/Generic';
import { BoxProps } from '../../../wag-react/next-components/box';
type PettedHealthArticleAdvertCardProps = Omit<BoxProps, 'background'> & {
  buttonHref?: string;
};
export const PettedHealthArticleAdvertCard = ({
  buttonHref,
  ...props
}: PettedHealthArticleAdvertCardProps) => <GenericHealthArticleAdvertCard subheading="Worried about the cost of treating your pet's symptoms?" content="Pet Insurance covers the cost of many common pet health conditions. Prepare for the unexpected by getting a quote from top pet insurance providers." button={{
  backgroundColor: '#42F8D7',
  textColor: 'black',
  label: 'Get a quote',
  href: buttonHref
}} background={{
  src: background,
  type: 'corner',
  color: '#7452FF'
}} logo={{
  alt: 'Petted logo',
  src: logoIcon
}} aspectRatio={['none', 'none', 'none']} minHeight={['300px', '300px', '300px']} maxHeight="unset" contentProps={{
  maxWidth: '350px',
  mb: ['5px', '35px']
}} imageContainerProps={{
  position: ['relative', 'absolute', 'absolute'],
  mt: ['-30px', '0', '0']
}} imageProps={{
  width: ['100%', '50%', '50%'],
  height: 'auto'
}} hoverBackgroundColor="white" hoverTextColor={wagwebTheme.colors.tropicalRainForest} {...props} data-sentry-element="GenericHealthArticleAdvertCard" data-sentry-component="PettedHealthArticleAdvertCard" data-sentry-source-file="Petted.tsx" />;